import { unsafeCSS, html } from "lit";
import { property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { LeafElement } from "../../components/leaf-element.js";
import "../../utilities/events.js";
const styles = "/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n/* ------------------------------------*\\\n    #TYPOGRAPHY PLACEHOLDERS\n\\*------------------------------------ */\n.base-c-value-props--columns-2, .base-c-value-props--columns-3, .base-c-value-props--columns-4 {\n  display: grid;\n}\n\n.base-c-value-props--background-white {\n  background: var(--leaf-color-bg-default);\n  border-radius: var(--leaf-border-radius-container);\n  padding: var(--leaf-spacing-32) !important;\n}\n@media (min-width: 48rem) {\n  .base-c-value-props--background-white {\n    padding: var(--leaf-spacing-48) !important;\n  }\n}\n@media (min-width: 60rem) {\n  .base-c-value-props--background-white {\n    padding: var(--leaf-spacing-64) !important;\n  }\n}\n\n.base-c-value-props--row {\n  display: grid;\n  gap: var(--leaf-spacing-48) var(--leaf-spacing-24);\n}\n\n@media (min-width: 48rem) {\n  .base-c-value-props--columns-2 {\n    grid-gap: var(--leaf-spacing-48) var(--leaf-spacing-24);\n    grid-template-columns: minmax(0, calc(((100% / 12) * 6) - 12px)) minmax(0, calc(((100% / 12) * 6) - 12px));\n  }\n}\n\n@media (min-width: 48rem) {\n  .base-c-value-props--columns-3 {\n    grid-gap: var(--leaf-spacing-48) var(--leaf-spacing-24);\n    grid-template-columns: minmax(0, calc(((100% / 12) * 4) - 16px)) minmax(0, calc(((100% / 12) * 4) - 16px)) minmax(0, calc(((100% / 12) * 4) - 16px));\n  }\n}\n\n@media (min-width: 48rem) {\n  .base-c-value-props--columns-4 {\n    grid-gap: var(--leaf-spacing-48) var(--leaf-spacing-24);\n    grid-template-columns: minmax(0, calc(((100% / 12) * 6) - 12px)) minmax(0, calc(((100% / 12) * 6) - 12px));\n  }\n}\n@media (min-width: 60rem) and (min-width: 60rem) {\n  .base-c-value-props--columns-4 {\n    grid-gap: var(--leaf-spacing-48) var(--leaf-spacing-24);\n    grid-template-columns: minmax(0, calc(((100% / 12) * 3) - 18px)) minmax(0, calc(((100% / 12) * 3) - 18px)) minmax(0, calc(((100% / 12) * 3) - 18px)) minmax(0, calc(((100% / 12) * 3) - 18px));\n  }\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
class BaseValueProps extends LeafElement {
  constructor() {
    super(...arguments);
    this.background = "transparent";
    this.columns = 1;
  }
  render() {
    const componentClassName = {
      "base-c-value-props": true,
      [`base-c-value-props--background-${this.background}`]: true
    };
    const columnsClassName = {
      "base-c-value-props--row": true,
      "base-c-value-props--columns-2": this.columns === 2,
      "base-c-value-props--columns-3": this.columns === 3,
      "base-c-value-props--columns-4": this.columns === 4
    };
    return html`<div class=${classMap(componentClassName)}>
      <slot name="heading"></slot>
      <div class=${classMap(columnsClassName)}>
        <slot></slot>
      </div>
    </div> `;
  }
}
BaseValueProps.styles = unsafeCSS(styles);
__decorateClass([
  property()
], BaseValueProps.prototype, "background", 2);
__decorateClass([
  property({ type: Number })
], BaseValueProps.prototype, "columns", 2);
export {
  BaseValueProps
};
//# sourceMappingURL=value-props.js.map
